import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
function DateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "4 0 16 16",
    height: "16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 0a1 1 0 011 1h4v15H4V1h4a1 1 0 112 0h4a1 1 0 011-1zm3 6H6v8h12zM9 7v2H7V7zm4 0v2h-2V7zm4 0v2h-2V7z",
    fill: "currentColor"
  }));
}
export default DateIcon;
//# sourceMappingURL=DateIcon.js.map